import { render, staticRenderFns } from "./commonStep.vue?vue&type=template&id=045c1d78&scoped=true"
import script from "./commonStep.vue?vue&type=script&lang=js"
export * from "./commonStep.vue?vue&type=script&lang=js"
import style0 from "./commonStep.vue?vue&type=style&index=0&id=045c1d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c1d78",
  null
  
)

export default component.exports